<mat-label *ngIf="field.label" [ngStyle]="field.labelStyles" [innerHTML]="field.label | gioNoSanitize"></mat-label>
<gio-custom-color [position]="field.options.picker.position" [align]="field.options.picker.align"
[gioEnableControl]="isEnabledFn(field.name, field.id)" [formControlName]="field.name"></gio-custom-color>
